<template>
  <div class="page-container">
    <div class="filter-container">
      <el-form :inline="true">
        <el-form-item :label="item.label" v-for="item in ipAllFilter" :key="item.label">
          <el-date-picker
            type="datetimerange"
            v-if="item.type === 'datetimerange'"
            v-model="form[item.start + '_' + item.end]"
            :default-time="['00:00:00', '23:59:59']"
            value-format="timestamp"
          ></el-date-picker>
          <el-select v-else-if="item.options" v-model="form[item.prop]" clearable="clearable">
            <el-option
              v-for="option in item.options"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            ></el-option>
          </el-select>
          <el-input v-else v-model="form[item.prop]"></el-input>
        </el-form-item>
        <div class="btn-container">
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">清空</el-button>
        </div>
      </el-form>
    </div>
    <div class="table-container">
      <el-table stripe :data="tableData">
        <el-table-column :label="item.label" v-for="(item, index) in ipAllTable" :key="index">
          <template slot-scope="scope">
            <span v-if="item.filter">{{ item.filter(scope.row) }}</span>
            <el-select
              v-else-if="item.prop === 'logLevel'"
              v-model="scope.row.logLevel"
              placeholder="请选择"
              @change="e => handleChange(scope.row.id, e)"
            >
              <el-option
                v-for="(log, idx) in options"
                :key="log.value"
                :label="log.label"
                :value="log.value"
              >
              <span v-if="idx === 0" style="color: gray">{{log.label}}</span>
              <span v-if="idx === 1" style="color: green">{{log.label}}</span>
              <span v-if="idx === 2" style="color: yellow">{{log.label}}</span>
              <span v-if="idx === 3" style="color: red">{{log.label}}</span>
              </el-option>
            </el-select>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑备注</el-button>
            <el-popconfirm
              v-if="scope.row.enabled === 1"
              title="是否冻结此账号"
              @onConfirm="handleStatus(scope.row.id, 2)"
            >
              <el-button type="text" size="small" slot="reference">冻结账号</el-button>
            </el-popconfirm>
            <el-popconfirm
              v-else
              title="是否解冻此账号"
              @onConfirm="handleStatus(scope.row.id, 1)"
            >
              <el-button type="text" size="small" slot="reference">解冻账号</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, prev, pager, next, jumper"
        :current-page="pageNo"
        :page-size="pageSize"
        :page-count="pageCount"
        :total="pageTotal"
        @current-change="onPageChange"
      ></el-pagination>
    </div>
    <el-dialog title="编辑备注" :visible.sync="dialogVisible" width="600px">
      <el-form :model="addForm" :rules="addRules" ref="addForm" label-width="0px" class="addForm">
        <el-form-item prop="remark">
          <el-input :rows="4" type="textarea" placeholder="请输入备注" v-model="addForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('addForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as R from 'ramda';
import moment from 'moment';
import { task as taskApi } from '@/api';

export default {
  name: 'IPError',
  data() {
    return {
      ipAllFilter: [],
      ipAllTable: [],

      options: [
        { label: '--', value: 1 },
        { label: '排除', value: 2 },
        { label: '低', value: 3 },
        { label: '高', value: 4 }
      ],
      form: {
        logLevel: ''
      },

      dialogVisible: false,

      addForm: {
        remark: '',
        id: ''
      },

      addRules: {
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
      },

      pageSize: 15,
      pageCount: 0,
      pageNo: 1,
      pageTotal: 0,

      tableData: []
    };
  },
  computed: {
    operates: ({ $route }) => $route.meta.operates
  },
  methods: {
    handleChange(id, level) {
      taskApi.logUpdateLogLevel({
        id,
        level
      })
        .then(res => {
          if (res.code === 10000) {
            this.$message.success('修改成功！');
            this.onSearch();
          }
        });
    },
    handleEdit(row) {
      this.addForm.remark = row.remark;
      this.addForm.id = row.id;
      this.dialogVisible = true;
    },
    async lazyLoad(node, resolve) {
      const { data } = await taskApi.areasList({
        code: node.value || ''
      });
      resolve(
        data.map(e => ({
          value: e.code,
          label: e.name,
          leaf: e.level >= 2
        }))
      );
    },
    handleStatus(id, status) {
      taskApi
        .logEnableUser({
          id,
          status
        })
        .then(res => {
          if (res.code === 10000) {
            if (status === 1) {
              this.$message.success('解冻账号成功！');
            } else {
              this.$message.success('冻结账号成功！');
            }
            this.onSearch();
          }
        });
    },
    getForm() {
      const { ipAllFilter } = this.$route.meta;
      const form = {};
      R.forEach(({ type, prop, start, end }) => {
        form[prop] = '';
        if (prop === 'logLevel') {
          form.logLevel = '';
        }
      }, ipAllFilter);
      this.form = form;
    },
    onOperateClick(row, item) {
      const { onClick } = item;
      if (onClick) {
        onClick(row, this);
      }
    },
    onReset() {
      this.getForm();
    },
    onCreated() {
      const { ipAllFilter, ipAllTable } = this.$route.meta;
      this.ipAllFilter = ipAllFilter;
      this.ipAllTable = ipAllTable;
      this.getForm();
      this.query();
    },
    onSearch() {
      this.query();
    },
    onPageChange(pageNo) {
      this.query(pageNo);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          taskApi.logAddRemark(this.addForm).then(res => {
            if (res.code === 10000) {
              this.dialogVisible = false;
              this.$message.success('操作成功！');
              this.onSearch();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleCancle() {
      this.resetForm('ruleForm');
      this.dialogVisible = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async query(pageNo = 1) {
      const { fetchDataName } = this.$route.meta;
      this.pageNo = pageNo;
      const submitForm = {};
      R.forEachObjIndexed((value, key) => {
        if (!value) return;
        const filterItem =
          R.find(R.propEq('prop', key), this.ipAllFilter) || {};
        if (/_/.test(key)) {
          // 是 datetimerange
          if (R.isEmpty(value)) return;
          const [startKey, endKey] = key.split('_');
          const [startValue, endValue] = value;
          submitForm[startKey] = moment(startValue).format(
            'YYYY-MM-DD HH:mm:ss'
          );
          submitForm[endKey] = moment(endValue).format('YYYY-MM-DD HH:mm:ss');
        } else {
          submitForm[key] =
            filterItem.dataType === 'number' ? Number(value) : String(value);
        }
      }, this.form);
      submitForm.type = 'login';
      submitForm.pageNo = this.pageNo;
      submitForm.pageSize = this.pageSize;

      let isEmpty = true;
      const formKeys = R.keys(this.form);
      R.forEach(key => {
        const value = this.form[key];
        if (
          (R.is(Array, value) && !R.isEmpty(value)) ||
          (R.is(String, value) && value !== '') ||
          R.is(Number, value)
        ) {
          isEmpty = false;
        }
      }, formKeys);
      let rq;
      if (isEmpty) {
        rq = taskApi[fetchDataName];
      } else {
        rq = taskApi['logList'];
        const { status } = this.$route.meta;
        if (!R.isNil(status)) {
          submitForm.status = status;
        }
      }
      const res = await rq(submitForm);
      if (res.code === 10000) {
        const { pageCount, data, total } = res.data;
        this.pageCount = pageCount;
        this.pageTotal = total;
        this.tableData = data;
      }
    }
  },
  created() {
    this.onCreated();
  },
  watch: {
    $route() {
      this.onCreated();
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/LogAudit/IPError.vue